import styles from './Footer.module.scss';
import logo from '../../assets/logo.png';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
function Footer() {
  const navigate = useNavigate();
  function handleBusinessInfoOPen() {
    window.open(
      'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=3158802344&apv_perm_no=',
      '',
      'width=750,height=700',
    );
  }
  const { t, i18n } = useTranslation();
  return (
    <div className={`${styles.container} ${isMobile ? styles.isMobile : ''}`}>
      <div style={{ maxWidth: '850px', margin: '0 auto' }}>
        <div className={styles.logoArea}>
          <img src={logo} alt="logo" />
        </div>
        <div className={styles.companyInfoWrap}>
          <h3 className={styles.companyName}>{t('footer.1')}</h3>
          <div className={styles.companyInfoLine}>
            <span>{t('footer.2')}</span>
            {/* <span>{t('footer.3')}</span> */}
            {/* <span
              className={styles.businessInfo}
              onClick={handleBusinessInfoOPen}
            >
              [{t('footer.4')}]
            </span> */}
          </div>
          {/* <div className={styles.companyInfoLine}>
            <span>{t('footer.5')}</span>
          </div> */}
          <div className={styles.companyInfoLine}>
            <span>{t('footer.6')}</span>
            <span>{t('footer.7')}</span>
          </div>
          <div className={styles.companyInfoLine}>
            <span>{t('footer.8')}</span>
          </div>
          <span className={styles.copyright}>
            Copyright(c) us.dietdr.co.kr. All Rights Reserved.
          </span>
          <ul className={styles.navigation}>
            <li onClick={() => navigate('/companyInfo')}>{t('footer.9')}</li>
            <li onClick={() => navigate('/terms')}>{t('footer.10')}</li>
            <li onClick={() => navigate('/guide')}>{t('footer.11')}</li>
            <li onClick={() => navigate('/unauthorizedEmailCollection')}>
              {t('footer.12')}
            </li>
            <li onClick={() => navigate('/privacy')}>{t('footer.13')}</li>
          </ul>
        </div>
      </div>

      <p className={styles.ondocInfo}>
        *{t('footer.14')}
        <br />
        {t('footer.15')}
      </p>
    </div>
  );
}
export default Footer;
